var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/RightHome.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var RightHome = function RightHome(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("style", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }, '.prefix__st0{fill:none}.prefix__st1{fill:#f2a619}.prefix__st2{fill:#0d4599}.prefix__st4{fill:#fff}'), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_2_1_",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_1-2",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M0 0h100v100H0z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M0 0h100v100H0z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__st1",
    d: "M93.4 73.8c-2.7-2.1-6.1 4.2-6.1 4.2s4.4-9.6.5-10c-1.6-.2-3.4 4-4.2 8.1 0-3.8-.9-6.9-2.3-7-3.9-.4-1.5 9.9-1.5 9.9l1 5.6h6.1c0-.1 9.1-8.8 6.5-10.8z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__st2",
    d: "M81.7 54L63.9 36.6 46.1 54l.1 30.6 35.6-.1z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006aff",
    d: "M26.5 54h19.6l.1 30.6-31.6.1-.1-30.6z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.118 .1)",
    className: "prefix__st4",
    d: "M53.1 62.8h7.7v9.4h-7.7z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.118 .124)",
    className: "prefix__st4",
    d: "M67.4 62.8h7.7v9.4h-7.7z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-.133 .053)",
    className: "prefix__st2",
    d: "M24.5 67.5H36v17.1H24.5z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd237",
    d: "M63.9 36.6l-31.6.1-17.8 17.4 31.6-.1z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__st2",
    d: "M44.9 19.7c-3.7-3.7-13.1-1-13.6 5.2-.7-6.2-9.4-9-13.3-5.6-3.9 3.5-4.2 9.4-.7 13.3l.3.3 13.6 13.6L44.9 33c3.7-3.7 3.7-9.6 0-13.3z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__st1",
    d: "M9.4 76.9c1.9-1.5 4.4 3 4.4 3s-3.2-6.9-.4-7.2c1.2-.1 2.4 2.9 3.1 5.8 0-2.7.7-5 1.6-5.1 2.8-.3 1.1 7.2 1.1 7.2l-.7 4H14s-6.5-6.2-4.6-7.7z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 17
    }
  }))));
};

RightHome.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
RightHome.defaultProps = {
  className: null
};
export default RightHome;